module["exports"] = [
  56,
  62,
  59
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/sv/cell_phone/common_cell_prefix.js
// module id = 3609
// module chunks = 1610